export default __webpack_public_path__ + "static/media/rishico-ico.4907d65a.svg";